<template>

    <ui-view class="view-ship-form" v-spinner="loading" :hide="loading">

        <ui-heading :title="pageTitle" icon="fa-ship">
            <ui-button color="positive" :loading="submitting" @click="$refs.form.submit()">Opslaan</ui-button>
            <ui-button
                v-if="shipId"
                color="negative"
                icon="magicon-trash"
                @click="deleteShip">Verwijderen</ui-button>

            <ui-button
                color="medium"
                type="bordered"
                @click="$router.go(-1)"
                slot="left">Annuleren</ui-button>
        </ui-heading>

        <ui-form-panel auto-validate ref="form" @submit="submit">

            <ui-form-input
                title="Naam"
                name="name"
                rules="required"
                v-model="pendingShip.name"/>

            <ui-form-dropdown
                v-if="!shipId && this.$user.role !== 'GROWER'"
                title="Kweker"
                name="growerId"
                :options="growerOptions"
                rules="required"
                v-model="pendingShip.growerId"/>

        </ui-form-panel>

    </ui-view>

</template>

<script>

import Vue from 'vue';
import { clone } from 'es-toolkit';
import Component from 'vue-class-component';

import createQuery from 'js-core/js/apollo/queries/createQuery';

import FindShipQuery from 'gql/queries/ShipForm/FindShip.gql';
import AllGrowersQuery from 'gql/queries/ShipForm/AllGrowers.gql';

import ShipMutations from 'app/mutations/ShipMutations';

@Component({

    name: 'ShipForm',
    apollo: {
        ship: createQuery(FindShipQuery, {

            skip() {

                return !this.shipId;
            },

            variables() {

                return {
                    id: this.shipId
                };
            },

            response(data) {

                this.pendingShip.name = data.name;
            }
        }),
        growers: createQuery(AllGrowersQuery, {

            skip() {

                return this.$user.role === 'GROWER';
            }
        })
    }
})
export default class ShipForm extends Vue
{
    loading = 0;
    submitting = false;

    pendingShip = {
        name: null,
        growerId: null
    };

    breadcrumb(){

        return [{
            title: 'Schepen',
            route: {
                name: 'ships'
            }
        }, this.pageTitle];
    }

    async submit() {

        this.submitting = true;
        let input = clone(this.pendingShip);

        try {

            if(this.shipId) {

                delete input.growerId;
                input.id = this.shipId;

                await ShipMutations.update(input);

                this.logger.info('Ship updated');
                this.$toast.success('Het schip is aangepast');
            }
            else {

                if(this.$user.role === 'GROWER') {
                    input.growerId = this.$user.growerId;
                }

                await ShipMutations.create(input);

                this.logger.info('Ship created');
                this.$toast.success('Het schip is aangemaakt');
            }

            this.$router.replace({
                name: 'ships'
            });
        }
        catch(e) {

            this.logger.error('Error creating/updating ship', e);
            this.$toast.error('Het schip kon niet worden opgeslagen');
        }

        this.submitting = false;
    }

    async deleteShip() {

        const { result, overlay } = await this.$alert.delete('Weet je zeker dat je dit schip wilt verwijderen?');
        if(!result) {
            return;
        }

        const id = this.shipId;
        try {

            await ShipMutations.delete(id);

            this.$toast.success('Het schip is succesvol verwijderd');
            this.$router.replace({ name: 'ships' });
        }
        catch(e) {

            this.logger.error(`Something went wrong while deleting ship ${id}:`, e);
            this.$toast.error('Er is iets fout gegaan tijdens het verwijderen van het schip');
        }

        this.$overlay.close(overlay);
    }

    get pageTitle(){

        return this.shipId ? this.$safe('ship.email') : 'Schip aanmaken';
    }

    get growerOptions() {

        if(!this.growers) {
            return [];
        }

        return this.growers.items.map(grower => ({
            label: grower.name,
            value: grower.id
        }));
    }

    get shipId() {

        return this.$route.params.id;
    }
}

</script>